<template>
	<div class="position-relative">
		<div class="search" @click="open">
			<div class="icon-search" >
				<svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-search"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" /><path d="M21 21l-6 -6" /></svg>
			</div>
		</div>

		<div class="search-bar" :class="{show}">
			<div class="container">
				<div class="search-content">
					<div class="spacer"></div>
					<div class="input-group">
						<form @submit.prevent="submitForm" @keydown.enter.prevent="submitForm">
							<input type="text" class="form-control" placeholder="Buscar..." ref="searchInput" v-model="searchInput" />
							<button type="submit" class="btn btn-sm" @click="submitForm">
								<svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-search"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" /><path d="M21 21l-6 -6" /></svg>
							</button>
						</form>
					</div>
					<div class="btn btn-close" @click="show=false">
						<svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-x"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M18 6l-12 12" /><path d="M6 6l12 12" /></svg>
					</div>
				</div>
			</div>

				
		</div>
	</div>
</template>

<script>
export default {
	name: "SearchNavbar",
	data() {
		return {
			loaded: false,
			searchInput: "",
			show: false,
		}
	},
	
	mounted(){
		// get search query from URL
		const urlParams = new URLSearchParams(window.location.search);
		const search = urlParams.get('search');
		if(search){
			this.searchInput = search;
			// this.show = true;
		}
	},

	methods: {
		open(){
			this.show = true;
			this.$refs.searchInput.focus();
		},
		submitForm() {
			console.log('submitForm');
			const searchText = this.searchInput;
			const searchURL = `/tienda?search=${encodeURIComponent(searchText)}`;

			// Redirigir a la URL deseada
			window.location.href = searchURL;

			// Otra opción (en lugar de window.location.href) si deseas usar el enrutador de Vue
			// this.$router.push(searchURL);
			},
	}
}
</script>
<style scoped lang="scss">
.search {
	position: relative;
}

.search-bar{
	position: fixed;
	top: -100px;
	right: 0px;
	left: 0px;
	background-color: #ffffff;
	width: 100%;
	height: 64px;
	transition: top 0.3s;
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 1001;

	&.show {
		top: 0px;
	}

	.search-content{
		display: flex;
		width: 100%;
	}

	.spacer{
		flex-grow: 1;
	}

	.input-group{
		flex-grow: 1;
		background-color: #f3f3f3;
		border-radius: 8px;

		max-width: 400px;
		
		form{
			width: 100%;

			input{
				flex-grow: 1;
			}
			display: flex;
		}

		.form-control{
			border: none;
			border-radius: 0px;
			box-shadow: none;
			background-color: transparent;
		}
	}
}



.icon-search {
	width: 26px;
	height: 26px;
	background-size: contain;
	color: #fff;
}

</style>
